"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/qualifying-event.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fqualifying-event.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.qualifyingEventToJSON = exports.qualifyingEventFromJSON = exports.QualifyingEvent = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.proto';
/**
 * Qualifying event for a user to be part of the tier.
 */
var QualifyingEvent;
(function (QualifyingEvent) {
    QualifyingEvent["INVALID_QUALIFYING_EVENT"] = "INVALID_QUALIFYING_EVENT";
    /**
     * DIRECT_DEPOSIT - Enrolled in the tier by meeting direct deposit requirements.
     */
    QualifyingEvent["DIRECT_DEPOSIT"] = "DIRECT_DEPOSIT";
    /**
     * DEPOSIT_SWITCH - Enrolled in the tier because of setting up direct deposit.
     */
    QualifyingEvent["DEPOSIT_SWITCH"] = "DEPOSIT_SWITCH";
    /**
     * SPONSOR_INHERITED - Enrolled in the tier due to the sponsor tier.
     */
    QualifyingEvent["SPONSOR_INHERITED"] = "SPONSOR_INHERITED";
    /**
     * MANUAL_ACTION - Enrolled in the tier by a manual action e.g. from admin web.
     */
    QualifyingEvent["MANUAL_ACTION"] = "MANUAL_ACTION";
    /**
     * PAYMENT - Enrolled in the tier through a payment e.g. Step Black.
     */
    QualifyingEvent["PAYMENT"] = "PAYMENT";
    /**
     * TRIAL - Enrolled in the tier through free trial.
     */
    QualifyingEvent["TRIAL"] = "TRIAL";
    QualifyingEvent["UNRECOGNIZED"] = "UNRECOGNIZED";
})(QualifyingEvent || (exports.QualifyingEvent = QualifyingEvent = {}));
function qualifyingEventFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_QUALIFYING_EVENT':
            return QualifyingEvent.INVALID_QUALIFYING_EVENT;
        case 1:
        case 'DIRECT_DEPOSIT':
            return QualifyingEvent.DIRECT_DEPOSIT;
        case 2:
        case 'DEPOSIT_SWITCH':
            return QualifyingEvent.DEPOSIT_SWITCH;
        case 3:
        case 'SPONSOR_INHERITED':
            return QualifyingEvent.SPONSOR_INHERITED;
        case 4:
        case 'MANUAL_ACTION':
            return QualifyingEvent.MANUAL_ACTION;
        case 5:
        case 'PAYMENT':
            return QualifyingEvent.PAYMENT;
        case 6:
        case 'TRIAL':
            return QualifyingEvent.TRIAL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return QualifyingEvent.UNRECOGNIZED;
    }
}
exports.qualifyingEventFromJSON = qualifyingEventFromJSON;
function qualifyingEventToJSON(object) {
    switch (object) {
        case QualifyingEvent.INVALID_QUALIFYING_EVENT:
            return 'INVALID_QUALIFYING_EVENT';
        case QualifyingEvent.DIRECT_DEPOSIT:
            return 'DIRECT_DEPOSIT';
        case QualifyingEvent.DEPOSIT_SWITCH:
            return 'DEPOSIT_SWITCH';
        case QualifyingEvent.SPONSOR_INHERITED:
            return 'SPONSOR_INHERITED';
        case QualifyingEvent.MANUAL_ACTION:
            return 'MANUAL_ACTION';
        case QualifyingEvent.PAYMENT:
            return 'PAYMENT';
        case QualifyingEvent.TRIAL:
            return 'TRIAL';
        case QualifyingEvent.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.qualifyingEventToJSON = qualifyingEventToJSON;
//# sourceMappingURL=qualifying-event.js.map